export default "__VITE_ASSET__3cf18c3f__"